// extracted by mini-css-extract-plugin
export default {"link":"BasketLink_link__3LkQJ","icon":"BasketLink_icon__hc8Z9","number":"BasketLink_number__WEGZh"};